import { useNavigate } from "react-router-dom";

const UserPostNavigation = () => {
  const navigate = useNavigate();

  const goToUserPosts = () => {
    navigate("/user-post"); // Ensure this route exists in your app
  };

  return { goToUserPosts }; // ✅ Return an object
};

export default UserPostNavigation;

